export default "__VITE_ASSET__bc75b974__"